
import Vue from 'vue';
import PDFPage from '@/components/pdf/PDFPage.vue';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { PDFPageProxy } from 'pdfjs-dist/types/src/display/api';
import { PDFController } from '@/components/pdf/PDFContext';

export default Vue.extend({
  name: 'PDFLoadingPage',
  components: { PDFPage },

  props: {
    pdf: { type: Object as () => PDFController, required: true },
    pageNo: { type: Number, required: true },
    width: { type: Number, required: true },
    ratio: { type: Number, default: 1.4142 },
  },

  data() {
    return {
      visible: false,
      loading: false,
      rendered: false,
      page: undefined as PDFPageProxy | undefined,
      error: undefined as Error | undefined,
    };
  },

  methods: {
    onRendered() {
      this.rendered = true;
    },
    onFailure(error?: Error) {
      this.error = error || new Error('undefined');
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    visibilityChanged(visible, entry) {
      this.visible = visible;
      if (visible && !this.loading && !this.page) {
        this.loading = true;
        this.pdf.page(this.pageNo)
          .then((page) => {
            this.page = page;
            this.loading = false;
          })
          .catch((e) => {
            this.error = e || new Error('undefined');
            this.loading = false;
          });
      }
    },
  },

});
